<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon title="Cancelar pedido" v-on="on" v-bind="attrs" color="error"
        ><v-icon>mdi-trash-can-outline</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title>Cancelar Pedido Nº {{ pedido.nrpedido }}</v-card-title>
      <v-card-subtitle>{{ pedido.descpessoa }}</v-card-subtitle>
      <v-card-text>
        <v-form ref="form">
          <v-textarea
            label="Motivo do cancelamento"
            rows="3"
            :rules="[(v) => !!v || 'Informe um motivo para o cancelamento']"
            v-model="motivo"
          ></v-textarea>
          <v-btn
            block
            rounded
            class="mt-3"
            color="error"
            depressed
            @click="cancelarPedido()"
            :loading="cancelando"
            >Confirmar cancelamento</v-btn
          >
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text rounded>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  props: {
    pedido: { type: Object, required: true },
  },
  watch: {
    dialog: function (open) {
      if (open) {
        this.motivo = "";
      }
    },
  },
  computed: {
    ...mapState("pedidos", ["pedidos"]),
  },
  data: () => ({
    dialog: false,
    cancelando: false,
    motivo: "",
    codstatus: 6,
  }),
  methods: {
    async cancelarPedido() {
      if (this.$refs.form.validate()) {
        this.cancelando = true;
        await axios
          .post(
            "/nutricao-animal/pedidos/cancelar-pedido",
            JSON.stringify({
              id: this.pedido.id,
              motivo: this.motivo,
            })
          )
          .then((res) => {
            if (res.data.success) {
              this.pedidos
                .filter((p) => p.id == this.pedido.id)
                .forEach((ped) => {
                  ped.status = res.data.data.status;
                  ped.podecancelar = res.data.data.podecancelar;
                  ped.descstatus = res.data.data.descstatus;
                  ped.coresstatus = res.data.data.coresstatus;
                });

              this.$toasted.success("Pedido cancelado com sucesso!");
              this.dialog = false;
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => this.$toasted.error(e));
        this.cancelando = false;
      }
    },
  },
};
</script>

<style>
</style>